<div class="header">
  <h2>Traceable component details</h2>
  <div class="header-buttons">
    <button mat-raised-button color="accent" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </div>
</div>

<loading-bar *ngIf="loading"/>

<p *ngIf="!loading && !traceableComponent">
  <strong>Traceable Component not found!</strong>
</p>

<div *ngIf="!loading && traceableComponent">
  <p><strong matTooltip="Database ID for the component">Traceable Component ID:</strong> {{ traceableComponent.Id }}</p>
  <p><strong matTooltip="Database ID of the parent component">Parent ID:</strong>
    <traceable-component-link [source]="source" [componentId]="traceableComponent.ParentId" />
  </p>
  <p><strong matTooltip="Asset ID to which the component is connected">Asset ID:</strong> <asset-link
      [assetId]="traceableComponent.AssetId" /></p>
  <p><strong matTooltip="Either factory or current component">Type:</strong> {{ source }}</p>
  <p><strong matTooltip="Material code of the component">Code:</strong> {{ traceableComponent.Code }}</p>
  <p><strong matTooltip="Serial number of traceable component">Serial Number:</strong> {{
    traceableComponent.SerialNumber }}</p>
  <p><strong matTooltip="Component description">Description:</strong> {{ traceableComponent.Description }}</p>
  <p><strong matTooltip="Status of a component">Status:</strong> {{ traceableComponent.Status }}</p>
  <p><strong matTooltip="Designation code of a component">Component Designation:</strong> {{
    traceableComponent.ComponentDesignation }}</p>
  <p><strong matTooltip="Creation date">Created:</strong> {{ traceableComponent.Created }}</p>
  <p><strong matTooltip="Last modification date">Modified:</strong> {{ traceableComponent.Modified }}</p>
  <p><strong matTooltip="Last modification done by">Modified By:</strong> {{ traceableComponent.ModifiedBy }}</p>
  <p><strong matTooltip="Designation code of a component">Project Name:</strong> {{ traceableComponent.ProjectName }}
  </p>
  <p><strong matTooltip="Sales order item id from the ordering system">Sales Order Traceable Component:</strong>
    {{ traceableComponent.SalesOrderItem }}</p>
  <p><strong matTooltip="Sales order id from the ordering system">Sales Order:</strong>
    {{ traceableComponent.SalesOrder }}</p>
  <p><strong>External Asset Reference:</strong> {{ traceableComponent.ExternalAssetReference }}</p>
  <p><strong>External Parent Component:</strong> {{ traceableComponent.ExternalParentComponent }}</p>
</div>